import { InjectionToken } from '@angular/core';

import type { OpenWeatherConfig } from '@asset-solutions/shared/config';

export const CUSTOMER_PORTAL_CONFIG = new InjectionToken<ConfigInterface>('AppConfig');

export function featureIsEnabled(feature: string, featureFlags?: { [key: string]: any }): boolean {
  if (!featureFlags) {
    return false;
  }

  const path = feature.split('.');

  let flag = featureFlags[path[0]];

  let index = 1;
  while (!!flag && index < path.length) {
    flag = flag[path[index++]];
  }

  return !!flag;
}

export interface ConfigInterface {
  alerts?: Record<string, { display: boolean; message: string }>;
  api: {
    gatewayPath: string;
    url: string;
  };
  enableAnalytics: boolean;
  firebase: {
    apiKey: string;
    authDomain: string;
    projectId: string;
    storageBucket: string;
    messagingSenderId: string;
    appId: string;
    measurementId: string;
  };
  featureFlags: {
    [key: string]: any;
  };
  logging: {
    logToConsole: boolean;
    logToServer: boolean;
  };
  mapsApiKey: string;
  orderSummary: {
    pollingInterval: number;
  };
  weather: OpenWeatherConfig;
}
